import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import { PAReviewModule } from "@/store/modules/paReview.module";
import EcTextEditor from "@/components/widgets/EcTextEditor.vue";
import { GuidItemModel } from "@/store/models/shared/guidItem";
let ReviewMeetingNotes = /** @class */ (() => {
    let ReviewMeetingNotes = class ReviewMeetingNotes extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.editorContent = "";
        }
        editorContentChanged(text) {
            this.editorContent = text;
        }
        saveNotes() {
            const notes = new GuidItemModel();
            notes.id = this.meetingId;
            notes.value = this.editorContent;
            PAReviewModule.upsertNotes(notes).then((result) => {
                if (result) {
                    this.$emit("cancel");
                }
            });
        }
        cancelNotes() {
            this.editorContent = this.reviewMeetingDetailNotes;
            this.$emit("cancel");
        }
        created() {
            this.editorContent = this.reviewMeetingDetailNotes != null ? this.reviewMeetingDetailNotes : "";
        }
        destroyed() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ReviewMeetingNotes.prototype, "reviewMeetingDetailNotes", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ReviewMeetingNotes.prototype, "meetingId", void 0);
    ReviewMeetingNotes = __decorate([
        Component({
            name: "ReviewMeetingNotes",
            components: {
                Loader,
                simplebar,
                EcTextEditor,
            },
        })
    ], ReviewMeetingNotes);
    return ReviewMeetingNotes;
})();
export default ReviewMeetingNotes;
